module.exports = __webpack_public_path__ + "static/img/biasfx2-looper.c5cd51f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/biasfx2-looper.png
// module id = BH0W
// module chunks = 12